import { useEffect, useState } from "react"
import { getTitle, getMargin } from "components/Dashboard/helpers"

const LeftTable = ({ bus }) => {
  return (
    <div className='left-half-of-table'>
      <div className='sub-title'>Bus</div>
      <table className='info-table'>
        <thead>
          <th>Outbound</th>
          <th>Schedule Pickup</th>
          <th>Notes</th>
          <th>Driver</th>
          <th>Stop</th>
          <th> Avail. Weight</th>
          <th>Avail. Length</th>
        </thead>
        <tbody>
          {bus.map((d, i) => {
            return (
              <tr key={i}>
                <td>{d.bus}</td>
                <td>{d.scheduled_pickup}</td>
                <td>{d.notes}</td>
                <td>{d.driver}</td>
                <td>{d.stop}</td>
                <td>{d.weight_available}</td>
                <td>{d.length_available}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const RightTable = ({ partial }) => {
  return (
    <div className='right-half-of-table'>
      <div className='sub-title'>Partial</div>
      <table className='info-table'>
        <thead>
          <th>Outbound</th>
          <th>Pro (B)</th>
          <th>Scheduled Pickup</th>
          <th>Notes</th>
        </thead>
        <tbody>
          {partial.map((d, i) => {
            return (
              <tr key={i}>
                <td>{d.bus}</td>
                <td>{d.full_order}</td>
                <td>{d.scheduled_pickup}</td>
                <td>{d.notes}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const InfoSection = ({ data, title }) => {
  const [bus, setBus] = useState([])
  const [partial, setPartial] = useState([])
  useEffect(() => {
    setBus(data.bus)
    const sortedPartial = [...data.partial].sort((a, b) => {
      if (!a.bus || !b.bus) return 0;

      const matchA = a.bus.match(/^([A-Za-z]+)(\d+)$/);
      const matchB = b.bus.match(/^([A-Za-z]+)(\d+)$/);

      if (!matchA || !matchB) return 0;

      const [, prefixA, numericA] = matchA;
      const [, prefixB, numericB] = matchB;

      if (prefixA !== prefixB) {
        return prefixA.localeCompare(prefixB);
      }
      return parseInt(numericA, 10) - parseInt(numericB, 10);
    });

    setPartial(sortedPartial)
  }, [])

  return (
    <div className="mx-2 my-4 pb-0">
      {(bus.length > 0 || partial.length > 0) && (
        <div
          className={`dashboard-summary-section shadow ${getMargin(title)} ${title}`}
        >
          <div className='title'>{getTitle(title)}</div>
          <div>
            <LeftTable bus={bus} />
            <RightTable partial={partial} />
          </div>
        </div>
      )}
    </div>
  )
}

const Summary = ({ data }) => {

  const summaryData = [
    {
      title: 'lrd',
      data: data.lrd
    },
    {
      title: 'dtw',
      data: data.dtw
    },
    {
      title: 'ckv',
      data: data.ckv
    }
  ]

  return (
    <>
      <div className="d-flex flex-sm-column flex-md-row flex-wrap justify-content-center">
        {summaryData
          .filter((data) => data.data.bus_count > 0)
          .map((data, index) => (
            <div key={index} className="flex-sm-row flex-md-column" style={{ flex: '1 1 0%' }}>
              <InfoSection data={data.data} title={data.title} />
            </div>
          ))}
      </div>
    </>

  )
}

export default Summary
